export enum PriceCalculateType {
  PER_AREA = 'PER_AREA',
  STATIC = 'STATIC'
}
